<template>
    <div>
        <v-row justify="center">
            <v-dialog v-model="loading" persistent max-width="290">
                <v-card class="text-center">
                    <v-card-text class="d-flex justify-center">
                        <v-progress-circular indeterminate color="primary" class="mt-4">
                        </v-progress-circular>
                    </v-card-text>
                    <v-card-subtitle>
                        Please wait...
                    </v-card-subtitle>
                </v-card>
            </v-dialog>
        </v-row>
    </div>
</template>

<script>
    export default {
        props: ['loading'],
        data(){
            return{
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>